import { useContext } from 'react';
import { BreakpointsContext } from '../contexts/BreakpointsContext';

export const useBreakpointsContext = () => {
  const context = useContext(BreakpointsContext);
  if (context === undefined) {
    throw new Error('useBreakpointsContext must be used within a BreakpointsProvider');
  }
  return context;
};
